// Story 11.5 — Zustand wrapper para el estado de validación. La lógica
// pura vive en `lib/validation-state.ts` para tests sin deps.

import { create } from 'zustand';
import type { ValidationProblem } from '@/lib/editor-types';
import {
  applyResult,
  initialValidationState,
  startValidation,
  type ValidationState,
} from '@/lib/validation-state';

export interface ValidationStore extends ValidationState {
  start(): void;
  setResult(errors: ValidationProblem[], warnings?: ValidationProblem[]): void;
  reset(): void;
}

export const useValidationStore = create<ValidationStore>()((set) => ({
  ...initialValidationState,
  start: () => set((s) => startValidation(s, Date.now())),
  setResult: (errors, warnings = []) => set((s) => applyResult(s, errors, warnings, Date.now())),
  reset: () => set(initialValidationState),
}));
